import { render, staticRenderFns } from "./form-setting.vue?vue&type=template&id=5b62b6c8&"
import script from "./form-setting.vue?vue&type=script&lang=js&"
export * from "./form-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports